import React from 'react';
import _ from 'lodash';
import ReactCodeMirror from '@skidding/react-codemirror';
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/sql/sql';
import 'codemirror/keymap/sublime';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/comment/continuecomment';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/search/match-highlighter';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/show-hint';

import './vbql/vbql.css';

import './vbql/mode';
import './vbql/hint';
import './vbql/prediction';

const hintRefRe = new RegExp('#\\b(\\w*)\\b');
const modeRefRe = new RegExp('^#(\\w*)');

const codeOptions = {
  mode: 'text/x-vbql',
  theme: 'hipster',
  highlightSelectionMatches: {
    trim: true,
  },
  lineWrapping: true,
  extraKeys: {
    'Cmd-Enter': () => console.log('test'),
    'Ctrl-Enter': () => console.log('test'),
    'Ctrl-Space': 'autocomplete',
  },
  autoCloseBrackets: true,
  lineNumbers: true,
  matchBrackets: true,
  addModeClass: true,
  refRe: modeRefRe,
  placeholder: 'Enter a VBQL query here.',
  showPredictions: true,
  hintOptions: {
    hint: CodeMirror.hint.vbql,
    refRe: hintRefRe,
    tables: [],
  },
  keyMap: 'sublime',
};

const mdOptions = {
  mode: 'markdown',
  keyMap: 'sublime',
  lineWrapping: true,
  theme: 'md',
  placeholder: 'Type Markdown here...',
  showPredictions: false,
};

const noop = () => {};

class VBQLArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value || '' };
    this.onChange = this.onChange.bind(this);
    this.update = _.debounce(this.update.bind(this), 100);
  }

  update(value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  onChange(value) {
    if (!_.isString(value)) {
      value = _.get(value, 'target.value', '');
    }
    this.setState({ value }, () => {
      this.update(value);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    const { value } = this.state;
    const {
      inline = true, readonly = false, onRun = noop, placeholder,
    } = this.props;
    const css = `vbql-area ${readonly ? 'vbql-area--readonly' : ''} ${inline ? 'vbql-area--inline' : ''}`;
    let configuredOptions;

    if (readonly) {
      configuredOptions = {
        ...codeOptions,
        readOnly: true,
      };
    } else {
      configuredOptions = {
        ...codeOptions,
        extraKeys: {
          ...codeOptions.extraKeys,
          'Cmd-Enter': onRun,
          'Ctrl-Enter': onRun,
        },
      };
    }

    if (placeholder) configuredOptions.placeholder = placeholder;

    return (
      <ReactCodeMirror
        key="a"
        className={css}
        value={value}
        onChange={this.onChange}
        options={configuredOptions}
      />
    );
  }
}

export default VBQLArea;
// padding: '54px 101px 65px 201px',
